module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page_title gradient_overlay",
    staticStyle: {
      "background": "url(/assets/images/page_title_bg.jpg)"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', {
    directives: [{
      name: "lang",
      rawName: "v-lang.blog",
      modifiers: {
        "blog": true
      }
    }]
  }), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    directives: [{
      name: "lang",
      rawName: "v-lang.inicio",
      modifiers: {
        "inicio": true
      }
    }],
    attrs: {
      "to": "/"
    }
  })], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "lang",
      rawName: "v-lang.blog",
      modifiers: {
        "blog": true
      }
    }]
  })])])])]), _vm._v(" "), _c('main', {
    staticClass: "blog"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_vm._l((_vm.posts), function(post) {
    return _c('article', {
      staticClass: "blog_list"
    }, [_c('div', {
      staticClass: "details"
    }, [_c('h2', [_c('a', [_vm._v(_vm._s(post.title))])]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('span', {
      staticClass: "meta_part"
    }, [_c('a', [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v(" "), (post.author) ? _c('span', [_vm._v("\n                                            " + _vm._s(post.author.firstname) + " " + _vm._s(post.author.lastname) + "\n                                        ")]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "meta_part"
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v("\n                                        " + _vm._s(_vm.formatDate(post.createdAt)) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(post.description)
      }
    })])])
  }), _vm._v(" "), _c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "prev_pagination",
    class: {
      disabled: _vm.currentPage <= 1
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.goTo(_vm.currentPage - 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })])]), _vm._v(" "), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      key: ("blog_page_" + page),
      class: {
        'active': page === _vm.currentPage
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.goTo(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', {
    staticClass: "next_pagination",
    class: {
      disabled: _vm.currentPage >= _vm.lastPage
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.goTo(_vm.currentPage + 1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('aside', {
    staticClass: "widget"
  }, [_c('last-posts')], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6099fbbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/blog/Blog.vue
// module id = 374
// module chunks = 0